import { message } from "antd";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const reports = async (token, type, company_tid, state, type_of_invoice, start_date, end_date) => {
	let body = {
		token,
		type,
		state,
		company_tid,
		type_of_invoice,
		start_date,
		end_date
	};
    
	// eslint-disable-next-line no-useless-catch
	try {
		const res = await axios.post(`${apiUrl}/reports`, body);
		if(res.status === 200) return res.data;    
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};
